import modal from '@/utils/modal.js';
import { defineAsyncComponent } from 'vue';

const TokenShop = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'./index.vue');
});

function openTokenShop () {
  // @TODO ensure merchant config initialized etc?
  const m = modal.create(TokenShop, true, {
    disableCloseButton: false,
    unwrapInjectedRef: true,
    labelledby: 'gmf-token-shop-title',
    describedby: 'gmf-token-shop-description',
  });
  m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
  m.body.classList.add('gmf-popup-token-shop');
}

export default openTokenShop;